import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36662f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-outfit-on-model" }
const _hoisted_2 = {
  ref: "tileWrapper",
  class: "frisbuy-outfit-on-model__wrapper"
}
const _hoisted_3 = {
  key: 0,
  ref: "tileTitle",
  class: "frisbuy-outfit-on-model__title"
}
const _hoisted_4 = {
  key: 1,
  class: "frisbuy-outfit-on-model__title__sample"
}
const _hoisted_5 = {
  key: 1,
  ref: "tileSubtitle",
  class: "frisbuy-outfit-on-model__subtitle"
}
const _hoisted_6 = {
  class: "products-scoll-block",
  ref: "swiper"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"frisbuy-outfit-on-model__navigation\" data-v-36662f82><button class=\"frisbuy-navigation-button frisbuy-prev-navigation-button\" data-v-36662f82><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-36662f82><rect width=\"24\" height=\"24\" transform=\"matrix(0 -1 1 0 0 24)\" fill=\"white\" fill-opacity=\"0.8\" data-v-36662f82></rect><path d=\"M9.5 18L14.5 12L9.5 6\" stroke=\"#303635\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-36662f82></path></svg></button><button class=\"frisbuy-navigation-button frisbuy-next-navigation-button\" data-v-36662f82><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-36662f82><rect width=\"24\" height=\"24\" transform=\"matrix(0 -1 1 0 0 24)\" fill=\"white\" fill-opacity=\"0.8\" data-v-36662f82></rect><path d=\"M9.5 18L14.5 12L9.5 6\" stroke=\"#303635\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-36662f82></path></svg></button></div>", 1)
const _hoisted_8 = { class: "frisbuy-outfit-on-model__kit-products swiper-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.titleMode !== 'hidden')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.titleMode === 'default')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Готовые комплекты ")
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.titleMode === 'postsCount')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Дополните образ (" + _toDisplayString(_ctx.productsList.length) + ") ", 1))
              : _createCommentVNode("", true)
          ], 512))
        : _createCommentVNode("", true),
      (_ctx.titleMode == 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Наводите на товар и переходите в карточку товара ", 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "frisbuy-outfit-on-model__kit",
        ref: "tileKit",
        style: _normalizeStyle({ height: _ctx.fashionTileKitHeight })
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
              return (_openBlock(), _createBlock(_component_ProductItem, {
                key: product.id,
                product: product,
                class: "swiper-slide",
                linkTarget: 
                Boolean(_ctx.popupSettings.targetBlankLink) ? '_blank' : '_self'
              ,
                isLiked: 
                Boolean(
                  _ctx.favoriteVendorList.find((el) =>
                    _ctx.isEqual(el, {
                      article: product.sku?.vendorCode,
                      offerId: product.sku?.offerId,
                      groupId: product.sku?.groupId,
                    })
                  )
                )
              ,
                onClickProduct: (product) => _ctx.sendProductAnalytics(product),
                onLike: () => _ctx.addProductToFavoriteList([product])
              }, null, 8, ["product", "linkTarget", "isLiked", "onClickProduct", "onLike"]))
            }), 128))
          ])
        ], 512)
      ], 4)
    ])), [
      [_directive_touch, (direction) => _ctx.changePostBySwipe(direction), "swipe"]
    ])
  ]))
}